module.exports = __webpack_public_path__ + "static/media/symmetric_block_arrow.a66bed9e.glb";